import { render, staticRenderFns } from "./CurrentDataUsage.vue?vue&type=template&id=03c75290&scoped=true&"
import script from "./CurrentDataUsage.vue?vue&type=script&lang=js&"
export * from "./CurrentDataUsage.vue?vue&type=script&lang=js&"
import style0 from "./CurrentDataUsage.vue?vue&type=style&index=0&id=03c75290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c75290",
  null
  
)

export default component.exports